export const PICKUP_POLICY_ENDPOINTS = {
  METADATA: 'admin/pickup_policy/metadata',
  FETCH: 'admin/pickup_policy/fetch_policy',
  SET: 'admin/pickup_policy/set_policy',
};

export const PICKUP_POLICY_STATUS = {
  NONE: 'NONE',       // initial — no search done yet
  EXISTS: 'EXISTS',   // data != null
  NOT_FOUND: 'NOT_FOUND', // data == null
};

export const SKELETON_ROWS = [
  { cols: 1, height: '2.4rem', width: '200px' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 1, height: '3.6rem', width: '130px' },
];
